// extracted by mini-css-extract-plugin
module.exports = {"icon":"ArrowIcon-module--icon--2ITd2","rotate":"ArrowIcon-module--rotate--H7Wqd"};